/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Button from '../common/Button';
import useAutofill from '../../redux/features/autofill/useAutofill';
import AutofillFields from './AutofillFields';

const useStyles = makeStyles(theme => ({
  ...theme.customTheme,
  applicationInfoContainer: {
    borderRadius: '4px',
    border: `1px solid ${theme.palette.border}`,
    padding: '2rem',
    marginBottom: '3rem',
    marginTop: '2rem',
  },
}));

export default function ConfirmAutofillDialog({ procedureId }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    updateConfirmAutofillDialogState,
    onCheckAnotherAction,
    onContinueAction,
    onFillManuallyAction,
    autofillFields,
    confirmAutofillDialogState,
    disableFillManuallyButton,
    hasConfirmationMessage,
  } = useAutofill(procedureId);

  return (
    <Dialog data-testId="confirm-autofill-dialog" open={confirmAutofillDialogState.open} fullWidth maxWidth="lg">
      <DialogTitle>
        <Typography component="h2" variant="h2" gutterBottom>
          {t('submission.epvl.autofill.title')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {t('submission.epvl.autofill.description')}
        <Box className={classes.applicationInfoContainer} sx={{ flexGrow: 1 }}>
          <Typography component="h3" variant="h3" gutterBottom>
            {t('submission.epvl.autofill.information')}
          </Typography>

          <AutofillFields autofillFields={autofillFields} />
          {hasConfirmationMessage && t('submission.epvl.autofill.confirmation.message')}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          data-testid="cancelAuotfill"
          color="default"
          onClick={() => updateConfirmAutofillDialogState({ open: false })}
        >
          {t('actions.cancel')}
        </Button>
        <Button
          data-testid="fillManually"
          color="default"
          disabled={disableFillManuallyButton}
          onClick={onFillManuallyAction}
        >
          {t('actions.fillManually')}
        </Button>
        <Button
          data-testid="checkAnother"
          color="default"
          type="submit"
          onClick={onCheckAnotherAction}
          disabled={false}
        >
          {t('actions.check.another')}
        </Button>
        <Button data-testid="confirmAutofill" color="primary" type="submit" onClick={onContinueAction} disabled={false}>
          {t('actions.use.information')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
